module.exports = __webpack_public_path__ + "img/ĐIỀU KHOẢN HOÃN HỦY SÂN GOLF-1.8a4a5cae.jpg";